import { TabView } from '@/features/app-tabs/tab-view';

/** Health landing tab — reference consumer of GET /user/health. */
export function HealthTabPage() {
  return <TabView tab="health" title="Health" />;
}
